module.exports = __webpack_public_path__ + "img/8d78eddea0fcd32f7133e04f084d8f71.png";